import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ContainerImages = styled.div`
  display: flex;
  gap: 10px;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
